import React from "react";
import styled from "styled-components";
const Wrapper = styled.div`
  position: relative;
  z-index: 1;
  text-align: center;
  bottom: 0;
  margin-top: 3rem;
  @media (max-width: 768px) {
    margin-top: 6rem;
  }
  hr {
    width: 55px;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
  }
  h3 {
    font-family: ${({ theme }) => theme.fonts.sofia};
    font-style: normal;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    margin-top: 1.5rem;
    line-height: 100%;
    color: ${({ theme }) => theme.white};
  }
  .old-price {
    font-weight: lighter;
    font-size: 0.8rem;
  }
  .new-price {
    font-weight: 500;
    font-size: 1.5rem;
    margin-top: 3.5rem;
  }
`;

function CardText({ oldprice, newprice }) {
  return (
    <Wrapper>
      <hr />
      <h3 className="old-price">A PARTIR DE {oldprice}</h3>
      <h3 className="new-price">{newprice}</h3>
    </Wrapper>
  );
}

export default CardText;
